import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class SmartAuthInterceptorInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const venueid    = localStorage.getItem('SmartVenueID')    ?? '';
    const businessid = localStorage.getItem('SmartBusinessID') ?? '';

    // For pinauth the user hasn't logged in yet — use the userid from the request body
    // rather than the stale/empty value in localStorage
    let userid = localStorage.getItem('SmartUserID') ?? '';
    if (request.url.includes('pinauth') && request.body && typeof request.body === 'object') {
      userid = (request.body as any).userid ?? userid;
    }

    request = request.clone({
      headers: request.headers
        .set('venueid',    venueid)
        .set('userid',     userid)
        .set('businessid', businessid)
        .set('venue',      'TRUE')
    });

    return next.handle(request);
  }
}
